import Heading from "../components/heading";
import SpaceBetween from "../components/space-between";
import PrimaryButton from "../components/primary-button";
import Section from "../components/section";
import List from "../components/list";
import { useContext, useEffect, useState } from "react";
import Recipe from "../models/recipe";
import NewRecipeModal from "../views/new-recipe-modal";
import FirebaseContext from "../utils/firebase-context";
import ListItem from "../components/list-item";
import EditRecipeModal from "../views/edit-recipe-modal";

export default function RecipeScreen() {
  const [recipes, setRecipes] = useState<Recipe[]>([]);
  const [showNewRecipeModal, setShowNewRecipeModal] = useState(false);
  const [showEditRecipeModal, setShowEditRecipeModal] = useState(false);
  const [recipe, setRecipe] = useState<Recipe>();

  const firebase = useContext(FirebaseContext);

  const openEditModal = (r: Recipe) => () => {
    setRecipe(r);
    setShowEditRecipeModal(true);
  };

  useEffect(() => {
    firebase.getRecipes().onSnapshot((snapshot) => {
      const rs: Recipe[] = [];
      snapshot.forEach((doc) => {
        rs.push(doc.data() as Recipe);
      });
      setRecipes(rs);
    });
  }, [firebase]);

  return (
    <>
      <Section>
        <SpaceBetween>
          <Heading>Alle Rezepte</Heading>
          <PrimaryButton onClick={() => setShowNewRecipeModal(true)}>
            Neues Rezept
          </PrimaryButton>
        </SpaceBetween>
      </Section>
      {recipes.length > 0 && (
        <Section>
          <List>
            {recipes.map((recipe) => (
              <ListItem key={recipe.id} onClick={openEditModal(recipe)}>
                {recipe.title}
              </ListItem>
            ))}
          </List>
        </Section>
      )}
      {showNewRecipeModal && (
        <NewRecipeModal close={() => setShowNewRecipeModal(false)} />
      )}
      {showEditRecipeModal && !!recipe && (
        <EditRecipeModal
          close={() => setShowEditRecipeModal(false)}
          initialRecipe={recipe}
        />
      )}
    </>
  );
}
